module.exports = __webpack_public_path__ + "static/img/X-ray_1.84f4b4fe.png";